import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { languageForLocation } from "../rendering/publicRoutes";
import en from "./locales/en/translation.json";
import it from "./locales/it/translation.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: typeof window === "undefined" ? "it" : languageForLocation(window.location.pathname, window.location.search),
    initImmediate: false,
    resources: {
      en: { translation: en },
      it: { translation: it },
    },
    fallbackLng: "it",
    supportedLngs: ["it", "en"],
    nonExplicitSupportedLngs: true,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["querystring", "localStorage", "navigator"],
      lookupQuerystring: "lng",
      caches: ["localStorage"],
    },
  });

// Keep <html lang> in sync with the active language for SEO + accessibility.
const syncHtmlLang = (lng) => {
  if (typeof document === "undefined") return;
  document.documentElement.lang = (lng || "it").slice(0, 2);
};
i18n.on("languageChanged", syncHtmlLang);
i18n.on("initialized", () => syncHtmlLang(i18n.language));

export default i18n;
